import { Dayjs } from 'dayjs'
import { Granularity } from '@/components/kol/common/time-granularity-selector'
import { DEFAULT_DATE_FORMAT } from '@/constants/date-format'

const formatDuration = (
  time: Dayjs,
  timeGranularity: Granularity,
  range?: boolean,
  customRangeStartDay?: Dayjs,
): string => {
  if (timeGranularity === 'day' && !range) {
    return time.format(DEFAULT_DATE_FORMAT)
  } else {
    const startTime = customRangeStartDay
      ? customRangeStartDay.format(DEFAULT_DATE_FORMAT)
      : time.startOf(timeGranularity).format(DEFAULT_DATE_FORMAT)

    const endTime = time.endOf(timeGranularity).format(DEFAULT_DATE_FORMAT)

    return `${startTime} ~ ${endTime}`
  }
}

export default formatDuration
